
import "/var/lib/jenkins/workspace/k8s-etmf-web-pro/src/components/RightContent/index.less?modules";
export default {"avatar": `avatar-dCcvFHjY`,"wrapper": `wrapper-REgM4b9V`}
